import { APP_ROUTES_ARRAY, useAppDispatch } from "@/utils";
import { useEffect, useMemo } from "react";
import { Outlet, useMatches } from "react-router";
import { dashboardReduxReducerActions } from "@/redux/actions/dashboard";

const InitRoot = () => {
  const memoRoutes = useMemo(() => APP_ROUTES_ARRAY(), []);
  const matches = useMatches();
  const dispatch = useAppDispatch();

  useEffect(() => {
    const last = matches.at(-1);

    if (last) {
      let pathName = last.pathname.trim();
      Object.entries(last.params).forEach(([key, value]) => {
        const paramPattern = new RegExp(`/${value}(/|$)`);
        pathName = pathName.replace(paramPattern, `/:${key}$1`);
      });

      const find = memoRoutes.find((i) => i.url === pathName);
      if (find?.meta?.isPage === true) {
        dispatch(dashboardReduxReducerActions.setLastUrlWasPage(last.pathname));
      }
    }
  }, [dispatch, matches, memoRoutes]);

  return (
    <div className="tw:flex tw:h-dvh">
      <Outlet />
    </div>
  );
};

export default InitRoot;
